import { QFilter } from '@/types';
import { SearchTreeNode } from '@/types/searchTreeTypes';
import { logger } from '@/util';
import { DomainCode } from '@australiangreens/ag-internal-components';
import callBackendApi from './call';
import { TagRecord } from './tags';

export const updatePathways = async (
  token: string,
  values: { stepId: number; optionId: number; domainCode: DomainCode; qFilter: QFilter }
) => {
  logger.debug('updatePathways() called', {});

  const data = await callBackendApi({
    token,
    method: 'put',
    endpoint: '/pathwaysteps',
    data: values,
  });

  return data;
};

export type UpdatePathwaysAdvData = {
  tree: SearchTreeNode;
  domainCode: DomainCode;
  updatePathwayStepId: number;
  updatePathwayOptionId: 1 | 2 | 3;
};

export const updatePathwaysAdv = async (token: string, data: UpdatePathwaysAdvData) =>
  callBackendApi({
    token,
    method: 'put',
    endpoint: '/pathwaysteps/adv',
    data,
  });

export const getPathwaySteps = async (token: string) => {
  return (
    (await callBackendApi({
      endpoint: '/pathwaysteps',
      token,
      method: 'get',
    })) as TagRecord[]
  )?.map((step) => ({ label: step.label, id: step.id }));
};

export const getPathwayStepsByIds = async (token: string, ids: number[]) => {
  return (
    (await callBackendApi({
      endpoint: `/pathwaysteps?ids=${JSON.stringify(ids)}`,
      token,
      method: 'get',
    })) as TagRecord[]
  )?.map((step) => ({ label: step.label, id: step.id }));
};
